var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcciojob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9182 18.4075L14.2023 11.68C14.134 11.6116 14.0233 11.6116 13.955 11.68L1.74183 23.9142C1.67354 23.9826 1.67354 24.0935 1.74183 24.1619L8.45772 30.8894C8.52602 30.9578 8.63674 30.9578 8.70503 30.8894L20.9182 18.6552C20.9865 18.5868 20.9865 18.4759 20.9182 18.4075Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2003 30.8554L40.8478 24.1965C40.9349 24.1091 40.9349 23.9675 40.8478 23.8802L28.703 11.7145C28.6159 11.6272 28.4745 11.6272 28.3873 11.7145L21.7398 18.3735C21.6527 18.4608 21.6527 18.6024 21.7398 18.6897L33.8846 30.8554C33.9717 30.9427 34.1131 30.9427 34.2003 30.8554Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9712 30.4269L21.4123 23.8566C21.3568 23.8011 21.267 23.8011 21.2115 23.8566L14.6526 30.4269C14.5971 30.4824 14.5971 30.5725 14.6526 30.628L21.2115 37.1982C21.267 37.2538 21.3568 37.2538 21.4123 37.1982L27.9712 30.628C28.0267 30.5725 28.0266 30.4824 27.9712 30.4269Z",
    fill: "#13335F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9712 11.1852L21.4123 4.61495C21.3568 4.55942 21.267 4.55942 21.2115 4.61495L14.6526 11.1852C14.5971 11.2407 14.5971 11.3308 14.6526 11.3863L21.2115 17.9566C21.2669 18.0121 21.3568 18.0121 21.4123 17.9566L27.9712 11.3863C28.0266 11.3308 28.0266 11.2407 27.9712 11.1852Z",
    fill: "#13335F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcciojob);
export default __webpack_public_path__ + "static/media/acciojob.a0e18247a670e5f2b11253496f7aba36.svg";
export { ForwardRef as ReactComponent };